import { render } from "./EntSalForm.vue?vue&type=template&id=9284fd4e"
import script from "./EntSalForm.vue?vue&type=script&lang=js"
export * from "./EntSalForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__